//#region IMPORT
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Components */
import { MEM_BASIC } from './index';
import { Button, Dialog, Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import useDelete from '../../../../hooks/useDeleteN';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import Commons from '../../../../Services/Common/Common';
import {
  Box,
  LinearProgress,
  Typography,
  Dialog as MuiDialog,
  DialogContent,
  DialogTitle,
  Button as MuiButton,
  IconButton,
  Paper,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AdminPanelSettingsRounded } from '@mui/icons-material';
import {
  useDelete1,
  useSave1,
  useSave3,
  useSave4,
  useSave5,
  useSave6,
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSearch5,
  useSearch6,
} from './MEM_BASIC_QUERY';
import { useSave } from '../../../../hooks/useSaveN';
import ExcelJS from 'exceljs';
import { getColumnDefs3 } from './MEM_BASIC_ColumnDefs';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'Member';
const DEFAULT_POSITION_LIST = [
  '안전관리자',
  '보건관리자',
  '안전보건관리담당자',
  '산업보건의',
  '관리감독자',
  '안전보건관리책임자',
  '안전보건총괄책임자',
  '명예산업안전감독관',
  '전담조직',
  // '근로자',
];

// 인력 권한 셀렉트박스에서 제외할 권한 코드
const EXCLUDED_AUTH_CODES = ['SITE_MANAGER', 'PARTNER', 'DEP_MANAGER'];

/** 조회 API 행 → 그리드 internalYn ('0' 내부인, '1' 외부인) */
const NormalizeInternalYnFromApiRow = (row) => {
  const yn = row?.internalYn ?? row?.InternalYn ?? row?.INTERNAL_YN;
  if (yn === 1 || yn === '1' || yn === true) return '1';
  if (yn === 0 || yn === '0' || yn === false) return '0';
  const legacy = row?.memberTypeCd ?? row?.MemberTypeCd ?? row?.MemTypeCd ?? '';
  const ls = String(legacy).trim().toUpperCase();
  if (ls === 'E' || ls === '1') return '1';
  if (ls === 'I' || ls === '0') return '0';
  return '0';
};

const NormalizeInternalYnFromExcelCell = (row) => {
  const raw = row?.internalYn ?? row?.memberTypeCd ?? '';
  const s = String(raw).trim();
  if (s === '1') return '1';
  if (s.toUpperCase() === 'E' || s.includes('외부')) return '1';
  return '0';
};

/** 엑셀 업로드 매칭·삭제 동기화용 행 키: 전화번호(로그인 ID) 숫자만(최대 11자), 없으면 tel로 보조 */
const NormalizeMemBasicExcelRowKey = (row) => {
  if (!row) return '';
  const fromId = String(row.id ?? row.ID ?? '')
    .replace(/\D/g, '')
    .slice(0, 11);
  if (fromId) return fromId;
  return String(row.tel ?? row.Tel ?? row.TEL ?? '')
    .replace(/\D/g, '')
    .slice(0, 11);
};

function MEM_BASICF() {
  //#region 변수
  //#region 공통 변수
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  //#endregion

  //#region Redux 관련
  const dispatch = useDispatch();
  const { companyInfo, userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((s) => s.SearchInfo);
  const approveRef = useRef('0');
  //#endregion

  //로그 관련
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 인원 유효성 검사 관련 변수
  const [contractMemberCount, setContractMemberCount] = useState(0); // 화사의 정해진 계약 인원
  const [employeeMemberCount, setEmployeeMemberCount] = useState(0); // 현재 Member의 수

  //#endregion

  //#region 그리드 변수
  const gridRef1 = useRef(); //사용자정보 그리드
  const gridRef2 = useRef(); //부서정보 그리드
  const gridRef3 = useRef(); //엑셀업로드

  const [clickRowId, setClickRowId] = useState(); // 현재 선택한 RowId
  const [depCodeList, setDepCodeList] = useState([]); //부서 list
  const [authCodeList, setAuthCodeList] = useState([]); //권한 list
  /* 그리드 기능 변수 */
  const [rowData1, setRowData1] = useState([]); // 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  const [clickRowIndex1, setClickRowIndex1] = useState(null);
  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row?.no ?? row?.id ?? row?.employeeNo,
    getKeyFromResult: (result) =>
      result?.no ?? result?.id ?? result?.Id ?? result?.employeeNo,
  });
  // 삭제 PayLoad
  const delete1 = useDelete1();

  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#endregion

  //#region 모달 변수
  const [modalToggle1, setModalToggle1] = React.useState(false); //권한상세(근로자) 설정하기 팝업
  const [modalRowData1, setModalRowData1] = useState([]); //권한상세(근로자) 설정하기 팝업 그리드 데이터
  const [selectedModalRowData1, setSelectedModalRowData1] = useState([]); //권한상세(근로자) 팝업 ROW선택 데이터

  const [modalSearchText, setModalSearchText] = useState(''); // 부서 목록 그리드 조회조건

  // 직책 선택 모달 변수
  const [modalToggle2, setModalToggle2] = React.useState(false); // 직책 선택 팝업
  const [selectedPositions, setSelectedPositions] = useState([]); // 선택된 직책 목록
  const [newPositionText, setNewPositionText] = useState(''); // 새 직책 입력 텍스트
  const [newlyAddedPositions, setNewlyAddedPositions] = useState([]); // 새로 추가한 직책 목록
  const [deletedPositions, setDeletedPositions] = useState([]); // 삭제된 직책 목록

  const [modalToggle3, setModalToggle3] = React.useState(false); // 총괄관리자 소속 선택 팝업
  const [modalRowData3, setModalRowData3] = useState([]); // 사업장 목록 그리드 데이터
  const [selectedModalRowData3, setSelectedModalRowData3] = useState({
    custCd: userInfo?.custCd ?? '',
    depCd: userInfo?.depCd ?? '',
  }); // 사업장 목록 그리드 데이터

  /** 총괄관리자 변경 — Search7 custList로 소속 사업장(custCd) 선택 */
  const [modalToggle4, setModalToggle4] = useState(false);
  const [selectedCustCd, setSelectedCustCd] = useState(null);
  const [selectedDepCd, setSelectedDepCd] = useState(null);

  //#endregion

  //#region 재로그인 안내(총괄관리자 변경 후)
  const [reloginDialogOpen, setReloginDialogOpen] = useState(false);
  const [reloginSecondsLeft, setReloginSecondsLeft] = useState(10);
  const reloginIntervalRef = useRef(null);
  const reloginRedirectedRef = useRef(false);
  const reloginOpenedRef = useRef(false);

  const redirectToLogin = useCallback(() => {
    if (reloginRedirectedRef.current) return;
    reloginRedirectedRef.current = true;

    if (reloginIntervalRef.current) {
      clearInterval(reloginIntervalRef.current);
      reloginIntervalRef.current = null;
    }

    // 인증 상태 해제 + 기본정보 초기화 후 로그인 화면으로 이동
    Commons.Storages('set', 'auth', { auth: false });

    setReloginDialogOpen(false);
    navigate('/');
  }, [navigate]);

  const openReloginDialog = () => {
    if (reloginOpenedRef.current) return;
    reloginOpenedRef.current = true;
    reloginRedirectedRef.current = false;
    setReloginSecondsLeft(10);
    setReloginDialogOpen(true);
  };

  useEffect(() => {
    if (!reloginDialogOpen) return;

    if (reloginIntervalRef.current) {
      clearInterval(reloginIntervalRef.current);
      reloginIntervalRef.current = null;
    }

    reloginIntervalRef.current = setInterval(() => {
      setReloginSecondsLeft((prev) => {
        const next = (prev ?? 0) - 1;
        if (next <= 0) {
          // interval 내부에서 바로 redirect 호출 시 setState 경쟁이 생길 수 있어 안전하게 분리
          clearInterval(reloginIntervalRef.current);
          reloginIntervalRef.current = null;
          setTimeout(() => redirectToLogin(), 0);
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => {
      if (reloginIntervalRef.current) {
        clearInterval(reloginIntervalRef.current);
        reloginIntervalRef.current = null;
      }
    };
  }, [reloginDialogOpen, redirectToLogin]);

  // Modal3 오픈 시 초기화(사업장 선택 후에만 부서 선택 가능)
  useEffect(() => {
    if (!modalToggle3) return;
    setSelectedModalRowData3({ custCd: '', depCd: '' });
    setModalRowData1([]);
    setSelectedModalRowData1([]);
  }, [modalToggle3]);

  // Modal3(총괄관리자 소속 변경)에서 사업장 선택 시 해당 사업장 부서 목록으로 갱신
  useEffect(() => {
    if (!modalToggle3) return;
    const cd = String(selectedModalRowData3?.custCd ?? '').trim();

    // 사업장 미선택/해제: 부서 잔상 제거만
    if (!cd) {
      setModalRowData1([]);
      setSelectedModalRowData1([]);
      // depCd는 클릭 핸들러에서 초기화하므로 여기서는 건드리지 않음(루프 방지)
      return;
    }

    // 사업장 선택됨: 부서 목록 재조회
    setModalRowData1([]);
    setSelectedModalRowData1([]);
    Search2({ search: { custCd: cd } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalToggle3, selectedModalRowData3?.custCd]);

  // Modal4 오픈 시 초기화(사업장 선택 후에만 부서 선택 가능)
  useEffect(() => {
    if (!modalToggle4) return;
    setModalRowData1([]);
    setSelectedModalRowData1([]);
    setSelectedDepCd(null);
  }, [modalToggle4]);

  // Modal4(총괄관리자 변경)에서 사업장 선택 시 해당 사업장 부서 목록으로 갱신
  useEffect(() => {
    if (!modalToggle4) return;
    if (!selectedCustCd) {
      // 사업장 선택 해제/미선택 시: 부서목록도 비움 (잔상 방지)
      setModalRowData1([]);
      setSelectedModalRowData1([]);
      return;
    }

    setModalRowData1([]);
    setSelectedModalRowData1([]);
    // useSearch2는 context.search.custCd를 사용하므로, 모달에서 선택한 custCd를 context로 전달
    Search2({ search: { custCd: selectedCustCd } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalToggle4, selectedCustCd]);
  //#endregion

  //#region 엑셀 변수
  const fileInputRef = useRef(null); //#파일 업로드 관련
  const [excelData, setExcelData] = useState([
    // 엑셀 데이터
    {
      depNm1: '영업본부',
      depNm2: '국내영업부',
      depNm3: '중부지사',
      depNm4: '영업2팀',
      authNm: '기본',
      position: '-',
      name: '홍길동',
      id: '01012345678',
      internalYn: '0',
      affiliationNm: '',
      // TEL: "'01012345678'",
      // BIRTH: '2000-12-12',
      tel: '01012345678',
      birth: '2025-11-19',
      bloodType: '',
      address: '부산광역시 중구 중앙대로 129 4층',
      nation: '대한민국',
      useYn: 'Y',
    },
  ]); //엑셀용 그리드 데이터
  const [excelImportModeOpen, setExcelImportModeOpen] = useState(false);
  const [pendingExcelImportFile, setPendingExcelImportFile] = useState(null);
  //#endregion

  //#region 엑셀 업/다운 (DEP_BASICF 패턴)
  const MEM_EXCEL_COLUMN_KEYS = [
    'depNm1',
    'depNm2',
    'depNm3',
    'depNm4',
    'authNm',
    'rank',
    'name',
    'id',
    'internalYn',
    'affiliationNm',
    'birth',
    'bloodType',
    'address',
    'nation',
  ];

  /**
   * 필드별 정규화: 다운로드 때 쓴 형식과 업로드 읽기 형식을 동일하게 맞춤
   * 두 값을 동일 형식으로 변환해 비교 가능하도록 함
   */
  const normalizeExcelField = (field, raw) => {
    if (raw === null || raw === undefined) raw = '';
    const s = String(raw).trim();

    if (field === 'id' || field === 'tel') {
      return s.replace(/\D/g, '').slice(0, 11);
    }
    if (field === 'internalYn') {
      return NormalizeInternalYnFromExcelCell({ internalYn: s });
    }
    if (field === 'birth') {
      if (!s) return '';
      // ExcelJS가 Date 객체로 줄 수도 있음 → YYYY-MM-DD로 통일
      if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
        return dayjs(raw).format('YYYY-MM-DD');
      }
      const d = dayjs(s.slice(0, 10));
      return d.isValid() ? d.format('YYYY-MM-DD') : s.slice(0, 10);
    }
    if (field === 'authNm') {
      return s || '기본';
    }
    if (field === 'bloodType') {
      return s || '';
    }
    if (field === 'nation') {
      return s || '대한민국';
    }
    return s;
  };

  const ExcelUpload1 = useCallback(
    async (file, importMode = 'append') => {
      if (!file) return;
      const isReplaceMode = importMode === 'replace';
      try {
        const arrayBuffer = await file.arrayBuffer();
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.worksheets[0];
        if (!worksheet) {
          dispatch(
            showSnackbar({
              message: '엑셀 시트를 불러오지 못했습니다.',
              type: 'warning',
            })
          );
          return;
        }

        // 헤더(다운로드 템플릿과 동일) → field 매핑
        const defs = getColumnDefs3().filter((c) => c.field !== 'position');
        const headerToField = new Map();
        defs.forEach((c) => {
          const header = String(c.headerName ?? '').trim();
          const field = String(c.field ?? '').trim();
          if (header && field) headerToField.set(header, field);
        });

        const headerRow = worksheet.getRow(1);
        const colCount = MEM_EXCEL_COLUMN_KEYS.length;
        const fieldKeys = [];
        for (let i = 1; i <= colCount; i++) {
          const cellVal = headerRow.getCell(i).value;
          const text =
            cellVal != null
              ? typeof cellVal === 'object' && cellVal.richText
                ? (cellVal.richText || []).map((t) => t?.text || '').join('')
                : String(cellVal).trim()
              : '';
          fieldKeys.push(
            headerToField.get(String(text).trim()) || String(text).trim()
          );
        }

        const uploadedData = [];
        let rowIndex = 2;
        const maxRows = 5000;
        while (rowIndex <= maxRows) {
          const row = worksheet.getRow(rowIndex);
          const rowObj = {};
          let hasAny = false;
          for (let i = 0; i < fieldKeys.length; i++) {
            const cell = row.getCell(i + 1);
            let value = cell.value;
            if (value !== null && value !== undefined) {
              hasAny = true;
              if (value instanceof Date && !Number.isNaN(value.getTime())) {
                // DEP_BASICF는 문자열로만 처리하지만, MEM은 birth 비교가 민감하므로 날짜는 명시 포맷
                const y = value.getFullYear();
                const m = String(value.getMonth() + 1).padStart(2, '0');
                const d = String(value.getDate()).padStart(2, '0');
                value = `${y}-${m}-${d}`;
              } else if (
                typeof value === 'object' &&
                value !== null &&
                value.richText
              ) {
                value = (value.richText || [])
                  .map((t) => t?.text || '')
                  .join('')
                  .trim();
              } else if (typeof value === 'number') {
                // 엑셀이 전화번호를 숫자 타입으로 저장하면 앞자리 0이 사라짐
                // id/tel 필드에서 10자리 숫자(한국 휴대폰 1xxxxxxxxx 형태)면 앞에 0 복원
                const currentField = fieldKeys[i];
                const s = String(Math.round(Math.abs(value)));
                if (
                  (currentField === 'id' || currentField === 'tel') &&
                  s.length === 10 &&
                  !s.startsWith('0')
                ) {
                  value = '0' + s;
                } else {
                  value = s;
                }
              } else {
                value = String(value).trim();
              }
            } else {
              value = '';
            }
            rowObj[fieldKeys[i] || `col${i + 1}`] = value;
          }
          if (!hasAny) break;

          // key = 전화번호(로그인 ID) 숫자만
          const key = NormalizeMemBasicExcelRowKey(rowObj);
          if (key) {
            rowObj.id = key;
            rowObj.tel = key;
            rowObj.no = rowObj.no || `new_${Date.now()}_${rowIndex}`;
            uploadedData.push(rowObj);
          }
          rowIndex++;
        }

        if (uploadedData.length === 0) {
          dispatch(
            showSnackbar({
              message: '읽을 수 있는 데이터가 없습니다.',
              type: 'warning',
            })
          );
          return;
        }

        const makeKeyString = (item) => NormalizeMemBasicExcelRowKey(item);
        const existingDataMap = new Map();
        (rowData1 || []).forEach((row) => {
          if (!row.deleteYn) {
            const key = makeKeyString(row);
            if (key) existingDataMap.set(key, row);
          }
        });

        const excelKeySet = new Set();
        uploadedData.forEach((row) => {
          const key = makeKeyString(row);
          if (key) excelKeySet.add(key);
        });

        const hasChanges = (existingRow, excelRow) => {
          for (const field of MEM_EXCEL_COLUMN_KEYS) {
            const a = normalizeExcelField(field, existingRow?.[field]);
            const b = normalizeExcelField(field, excelRow?.[field]);
            if (a !== b) {
              console.debug(
                `[MEM엑셀비교] 필드=${field} 기존="${a}" 업로드="${b}"`
              );
              return true;
            }
          }
          return false;
        };

        const newRows = [];
        const updatedRows = [];
        const updatedKeys = new Set();

        for (const excelRow of uploadedData) {
          const key = makeKeyString(excelRow);
          if (!key) continue;
          if (existingDataMap.has(key)) {
            if (!isReplaceMode) continue;
            const existingRow = existingDataMap.get(key);
            if (hasChanges(existingRow, excelRow)) {
              updatedRows.push({
                ...existingRow,
                ...excelRow,
                newYn: existingRow.newYn === 'Y' ? 'Y' : undefined,
                editYn: existingRow.newYn === 'Y' ? undefined : 'Y',
                excel: 'Y',
                no: existingRow.no,
              });
              updatedKeys.add(key);
            }
          } else {
            newRows.push({
              ...excelRow,
              newYn: 'Y',
              excel: 'Y',
              no: excelRow.no || `new_${Date.now()}_${Math.random()}`,
            });
          }
        }

        const rowsToDelete = [];
        if (isReplaceMode) {
          (rowData1 || []).forEach((row) => {
            if (!row.deleteYn) {
              const key = makeKeyString(row);
              if (key && !excelKeySet.has(key)) {
                rowsToDelete.push({ ...row, deleteYn: 'Y' });
              }
            }
          });
        }

        const updatedRowData = (rowData1 || []).map((row) => {
          if (row.deleteYn) return row;
          const key = makeKeyString(row);
          if (key && updatedKeys.has(key)) {
            const updated = updatedRows.find((r) => makeKeyString(r) === key);
            if (updated) return updated;
          }
          if (rowsToDelete.some((rd) => rd.no === row.no)) {
            return { ...row, deleteYn: 'Y' };
          }
          return row;
        });

        const finalRowData = [...updatedRowData, ...newRows];
        setRowData1(finalRowData);
        setChangedRowData1(
          finalRowData.filter((row) => row.newYn === 'Y' || row.editYn === 'Y')
        );
        if (rowsToDelete.length > 0) {
          const existingDeleted = Array.isArray(deletedRowData1)
            ? deletedRowData1
            : [];
          const added = rowsToDelete.filter(
            (rd) => !existingDeleted.some((ed) => ed.no === rd.no)
          );
          setDeletedRowData1([...existingDeleted, ...added]);
        }
        const appliedCount = updatedRows.length + newRows.length;
        const actionText = isReplaceMode
          ? '기존 내역을 덮어썼습니다'
          : '신규 행으로 추가했습니다';
        let msg =
          appliedCount > 0
            ? `엑셀 ${uploadedData.length}건 중 ${appliedCount}건을 ${actionText}.`
            : isReplaceMode
              ? '변경·추가할 인력이 없습니다.'
              : '추가할 신규 인력이 없습니다. 동일 전화번호는 기존 내역을 유지합니다.';
        if (isReplaceMode && rowsToDelete.length > 0) {
          msg += ` 엑셀에 없어 삭제 표시: ${rowsToDelete.length}건`;
        }
        dispatch(
          showSnackbar({
            message: msg,
            type: 'success',
          })
        );
      } catch (error) {
        console.error('Excel upload error:', error);
        dispatch(
          showSnackbar({
            message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
            type: 'error',
          })
        );
      }
    },
    [deletedRowData1, dispatch, rowData1]
  );

  const HandleExcelFileInputChange = useCallback((file) => {
    setPendingExcelImportFile(file);
    setExcelImportModeOpen(true);
  }, []);

  const HandleExcelImportModeClose = useCallback(() => {
    setExcelImportModeOpen(false);
    setPendingExcelImportFile(null);
  }, []);

  const HandleExcelImportModeSelect = useCallback(
    (mode) => {
      const file = pendingExcelImportFile;
      setExcelImportModeOpen(false);
      setPendingExcelImportFile(null);
      if (!file) return;
      void ExcelUpload1(file, mode);
    },
    [ExcelUpload1, pendingExcelImportFile]
  );

  const ExcelDownload1 = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('인력관리', {
        views: [{ state: 'frozen', ySplit: 1 }],
      });

      const defs = getColumnDefs3().filter((c) => c.field !== 'position');
      const fieldToHeader = {};
      defs.forEach((c) => {
        if (c.field) fieldToHeader[c.field] = c.headerName;
      });
      const headers = MEM_EXCEL_COLUMN_KEYS.map((k) => fieldToHeader[k] || k);

      const headerRow = sheet.getRow(1);
      headers.forEach((h, i) => {
        const cell = headerRow.getCell(i + 1);
        cell.value = h;
        cell.font = { bold: true };
      });
      headerRow.commit();

      // 그리드에 보이는 데이터 기준으로 다운로드(삭제 예정만 제외)
      const detailData = (rowData1 || []).filter((r) => !r.deleteYn);
      detailData.forEach((item, index) => {
        const row = sheet.getRow(2 + index);
        MEM_EXCEL_COLUMN_KEYS.forEach((key, i) => {
          const cell = row.getCell(i + 1);
          const cellValue = normalizeExcelField(
            key,
            key === 'id'
              ? NormalizeMemBasicExcelRowKey(item)
              : (item[key] ?? '')
          );
          // numFmt='@' 먼저 설정해야 ExcelJS가 문자열로 저장 → 앞자리 0(전화번호 등) 보존
          cell.numFmt = '@';
          cell.value = cellValue;
        });
        row.commit();
      });

      const fileName = `${dayjs().format('YYYYMMDD_HHmmss')}_인력관리.xlsx`;
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
      dispatch(
        showSnackbar({
          message: '엑셀 다운로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel download error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 다운로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
    }
  };

  // 회사 코드 변경 시 직책 목록 조회
  useEffect(() => {
    if (searchInfo.coCd) {
      Search5();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInfo.coCd]);
  //#endregion

  //#region 조회
  // 그리드 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (processedRows) => {
      const rows = (processedRows || []).map((r) => {
        const internalYn = NormalizeInternalYnFromApiRow(r);
        const baseCd = authCodeList.find((i) => i.name === '기본')?.value;
        const base = {
          ...r,
          internalYn,
          affiliationNm:
            r?.affiliationNm ?? r?.AffiliationNm ?? r?.AFFILIATION_NM ?? '',
        };
        if (internalYn !== '1') return base;
        return {
          ...base,
          authNm: '기본',
          position: '',
          depNm1: '',
          depNm2: '',
          depNm3: '',
          depNm4: '',
          depCd: '',
          ...(baseCd != null ? { authCd: baseCd } : {}),
        };
      });
      setRowData1(rows);
      setExcelData(rows.filter((f) => f.useYn === 'Y'));
    },
  });

  const SearchLogic1 = async () => {
    ResetLogic1();
    if (!validateSelection()) return;

    setLoading(true);
    try {
      await Search1();
      await Search5(); // 직책 목록 조회
    } finally {
      await Search4();
      setLoading(false);
    }
  };

  // 부서 조회
  const { run: Search2 } = useSearch2({
    dateKey: 'birth',
    onSuccess: (rows) => {
      setModalRowData1(rows);
    },
  });
  const SearchLogic2 = () => {
    setModalRowData1([]);
    setSelectedModalRowData1([]);
    Search2();
  };

  // 권한 조회 (셀렉트박스에서 SITE_MANAGER, PARTNER, DEP_MANAGER 제외)
  const { refetch: Search3 } = useSearch3({
    onSuccess: (formattedList) => {
      const filtered = (formattedList || []).filter(
        (item) => !EXCLUDED_AUTH_CODES.includes(item.value)
      );
      setAuthCodeList(filtered);
    },
  });

  // 회사 계약인원 불러온 뒤 유효성 검사
  const { refetch: Search4 } = useSearch4({
    onSuccess: (data) => {
      setContractMemberCount(data?.contractMemberCount);
      setEmployeeMemberCount(data?.employeeMemberCount);
    },
  });
  // 직책 조회
  const [positionList, setPositionList] = useState([]); // 직책 목록
  const { refetch: Search5 } = useSearch5({
    onSuccess: () => {
      setPositionList([
        { cpNm: '안전관리자' },
        { cpNm: '보건관리자' },
        { cpNm: '안전보건관리담당자' },
        { cpNm: '산업보건의' },
        { cpNm: '관리감독자' },
        { cpNm: '안전보건관리책임자' },
        { cpNm: '안전보건총괄책임자' },
        { cpNm: '명예산업안전감독관' },
        { cpNm: '중대재해 전담조직' },
      ]);
    },
  });

  const { run: search6 } = useSearch6({
    onSuccess: (rows) => {
      setModalRowData3(rows);
    },
  });
  //#endregion

  //#region 저장
  //저장버튼 클릭 시 함수
  const { runAsync: Save1Async } = useSave1({
    companyInfo,
    authCodeList,
  });

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '본부',
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,

    requestSave: (rows) => Save1Async(rows),

    requestDelete: deleteHandler1.DeleteLogic,

    reset: () => ResetLogic1(),
    refresh: () => SearchLogic1(),

    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      }),
  });

  /** 저장 시 직책 목록에 없는 값이 있으면 직책 추가(Save4) 후 인력 저장(Save1) */
  const SaveLogic1 = async () => {
    const normalize = (v) => String(v ?? '').trim();
    const splitPositions = (value) =>
      String(value ?? '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    const changedRows = changedRowData1.filter((r) => !r.deleteYn);

    // 성명 필수 체크
    const emptyNameRows = changedRows.filter((row) => !normalize(row?.name));
    if (emptyNameRows.length > 0) {
      dispatch(
        showSnackbar({
          message: '성명을 입력하세요.',
          type: 'warning',
        })
      );
      return;
    }

    const commaInNameRows = changedRows.filter((row) =>
      normalize(row?.name).includes(',')
    );
    if (commaInNameRows.length > 0) {
      dispatch(
        showSnackbar({
          message: '성명에 쉼표(,) 기호를 사용할 수 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // 신규 행 ID 필수
    const emptyIdNewRows = changedRows.filter(
      (row) => row.newYn === 'Y' && !normalize(row?.id)
    );
    if (emptyIdNewRows.length > 0) {
      dispatch(
        showSnackbar({
          message: 'ID를 입력하세요.',
          type: 'warning',
        })
      );
      return;
    }

    const positionValuesInSave = [
      ...new Set(changedRows.flatMap((r) => splitPositions(r?.position))),
    ];
    if (positionValuesInSave.length === 0) {
      await Save1();
      return;
    }

    let baseList = [];
    if (positionList && positionList.length > 0) {
      baseList = positionList.map((p) => normalize(p?.cpNm ?? p?.CpNm ?? p));
    } else {
      baseList = (DEFAULT_POSITION_LIST || []).map(normalize);
    }
    const added = (newlyAddedPositions || []).map(normalize).filter(Boolean);
    const deleted = (deletedPositions || []).map(normalize).filter(Boolean);
    const effectiveSet = new Set(
      [...baseList, ...added].filter((p) => !deleted.includes(p))
    );

    const missing = positionValuesInSave.filter(
      (p) => !effectiveSet.has(normalize(p))
    );
    if (missing.length > 0) {
      try {
        await Search5();
      } catch (e) {
        console.error(e);
        dispatch(
          showSnackbar({
            message: e?.message || '안전보건조직 저장 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
        return;
      }
    }

    await Save1();
  };

  //엑셀 업로드 시 저장 함수
  const SaveLogic2 = async () => {
    setLoading(true);
    try {
      const changedRows = changedRowData1.filter((row) => !row.deleteYn);
      if (!changedRows.length) {
        dispatch(
          showSnackbar({
            message: '저장할 데이터가 없습니다.',
            type: 'warning',
          })
        );
        setLoading(false);
        return;
      }

      const invalidRows = changedRows.filter((item) => {
        if (item.newYn !== 'Y') return false;
        const idVal = item.id ?? item.ID;
        if (typeof idVal === 'string') return idVal.trim() === '';
        if (typeof idVal === 'number') return false;
        return !idVal;
      });
      if (invalidRows.length > 0) {
        dispatch(
          showSnackbar({ message: '신규 행의 ID를 입력하세요.', type: 'error' })
        );
        setLoading(false);
        return;
      }

      await Save1();
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
      setLoading(false);
    }
  };
  //#region 승인, 승인취소
  //승인버튼 클릭 시
  const { runAsync: Save3Async } = useSave3();
  const { run: SaveLogic3 } = useSave({
    menuId: SCREEN_MENU_ID,
    getSelectedRows: () => selectedRowData1,
    getChangedRows: () => selectedRowData1,
    requestSave: (rows) => Save3Async({ rows, approve: approveRef.current }),
    refresh: () => SearchLogic1(),
  });
  //직책 추가
  const { runAsync: Save4Async } = useSave4();
  const { run: SaveLogic4 } = useSave({
    menuId: SCREEN_MENU_ID,
    getChangedRows: () => {
      const normalize = (v) => String(v ?? '').trim();
      let existing = [];
      if (positionList && positionList.length > 0) {
        existing = (positionList || [])
          .map((p) => normalize(p?.cpNm ?? p?.CpNm ?? p))
          .filter(Boolean);
      } else {
        existing = DEFAULT_POSITION_LIST;
      }

      // ✅ 새로 추가한 직책 목록(UI에서 추가된 것)
      const added = (newlyAddedPositions || [])
        .map((nm) => normalize(nm))
        .filter(Boolean);
      // ✅ 삭제된 직책 목록
      const deleted = (deletedPositions || [])
        .map((nm) => normalize(nm))
        .filter(Boolean);
      // ✅ 중복 제거 후 삭제된 직책 제외
      const allPositions = Array.from(new Set([...existing, ...added]));
      const unique = allPositions.filter((pos) => !deleted.includes(pos));
      // ✅ 문자열 배열을 객체 배열로 변환: [{cpNm: "사업주"}, {cpNm: "안전관리자"}, ...]
      const result = unique.map((cpNm) => ({ cpNm }));
      return result;
    },
    requestSave: (rows) => Save4Async(rows),

    refresh: () => {
      // 저장 후 직책 목록 재조회
      Search5();
      setNewlyAddedPositions([]); // 저장 후 새로 추가한 목록 초기화
      setDeletedPositions([]); // 저장 후 삭제된 목록 초기화
    },
  });
  // 총괄관리자 소속 변경
  const { runAsync: Save6Async } = useSave6();
  const { run: SaveLogic6 } = useSave({
    menuId: SCREEN_MENU_ID,
    getChangedRows: () => {
      const custCd = selectedModalRowData3?.custCd ?? '';
      const depCd = selectedModalRowData3?.depCd ?? '';
      return [{ custCd, depCd }];
    },
    requestSave: (rows) => Save6Async({ rows }),
    refresh: () => {
      setModalToggle3(false);
      Search1();
    },
  });
  //총괄관리자 변경
  const { runAsync: Save5Async } = useSave5();
  const { run: Save5 } = useSave({
    menuId: SCREEN_MENU_ID,
    getChangedRows: () => {
      return selectedRowData1;
    },
    requestSave: (rows) => {
      const custCd = selectedCustCd ?? '';
      const depCd = selectedDepCd ?? '';
      const newRows = (rows || []).map((r) => ({
        ...r,
        custCd: custCd || r?.custCd,
        depCd: depCd || r?.depCd,
      }));
      return Save5Async(newRows);
    },
    afterSaveRow: (_row, { savedRows }) => {
      // 저장 성공 시에만 재로그인 안내 (실패 시에는 이동시키지 않음)
      const ok = (savedRows || []).some((r) => r?.isSuccess === true);
      if (ok) openReloginDialog();
    },
    refresh: () => {
      setModalToggle4(false);
      setSelectedCustCd(null);
      SearchLogic1();
    },
  });

  /** 총괄관리자 변경: 사업장 목록(Search7) → 선택 후 저장 → 성공 시 권한변경 안내 팝업 */
  const AppointBusinessOwner = async () => {
    try {
      if (selectedRowData1.length !== 1) {
        dispatch(
          showSnackbar({
            message: '한명의 사용자만 선택 후 다시 시도하세요.',
            type: 'warning',
          })
        );
        return;
      }
      setSelectedCustCd(null);
      setSelectedDepCd(null);
      setModalToggle4(true);
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: '사업장 목록을 불러오지 못했습니다.',
          type: 'error',
        })
      );
      setModalToggle4(false);
    }
  };

  const CancelAppointBusinessOwner = () => {
    setModalToggle4(false);
    setSelectedCustCd(null);
    setSelectedDepCd(null);
  };

  const ConfirmAppointBusinessOwner = async () => {
    try {
      if (!selectedCustCd || String(selectedCustCd).trim() === '') {
        dispatch(
          showSnackbar({
            message: '총괄관리자 소속 사업장을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      }
      if (!selectedDepCd || String(selectedDepCd).trim() === '') {
        dispatch(
          showSnackbar({
            message: '총괄관리자 소속 부서를 선택하세요.',
            type: 'warning',
          })
        );
        return;
      }
      await Save5();
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#region 나머지 함수
  /**
   * 계약 인원 유효성 검사
   * @param {boolean} isSaveAction - 저장 버튼 클릭인지 여부
   * @returns {boolean} true: 유효, false: 초과 또는 추가 불가
   */
  const validateContractMember = (isSaveAction = false) => {
    // 그리드 전체 ROW
    const allRowData = [];
    gridRef1.current.api.forEachNode((node) => {
      allRowData.push(node.data);
    });
    // 신규 추가 인원 수 계산
    const newCount = allRowData.reduce(
      (cnt, row) => cnt + (row.newYn === 'Y' ? 1 : 0),
      0
    );
    // 총 인원 합계
    const totalAfterChange = employeeMemberCount + newCount;

    // 초과 여부
    const exceed = totalAfterChange > contractMemberCount;

    if (isSaveAction) {
      // 저장 버튼 클릭 시
      if (exceed) {
        const exceedCount = totalAfterChange - contractMemberCount;
        dispatch(
          showSnackbar({
            message: `계약 인원 초과! 최대 (${contractMemberCount})명 (${exceedCount}명 초과)`,
            type: 'warning',
          })
        );
        return false; // 저장 중단
      }
    } else {
      // 저장 버튼이 아닌 경우
      // 추가 인원이 0명인 경우 [이미 계약인원이 꽉 찼을 때]
      if (newCount === 0 && contractMemberCount === employeeMemberCount) {
        dispatch(
          showSnackbar({
            message: `추가 불가: 현재 인원 (${employeeMemberCount}명) = 최대 계약 인원 (${contractMemberCount}명)`,
            type: 'warning',
          })
        );
        return false; // 추가 불가
      }

      if (totalAfterChange >= contractMemberCount) {
        dispatch(
          showSnackbar({
            message: `추가 불가: 현재 인원 (${employeeMemberCount}명) + 추가 인원 (${newCount}명) = 최대 계약 인원 (${contractMemberCount}명)`,
            type: 'warning',
          })
        );
        return false; // 추가 불가
      }
    }

    return true; // 유효
  };
  const validateExcelSave = () => {
    const changedRows = changedRowData1.filter((row) => !row.deleteYn);

    if (!changedRows.length) {
      dispatch(
        showSnackbar({ message: '저장할 데이터가 없습니다.', type: 'warning' })
      );
      return false;
    }

    const invalidRows = changedRows.filter((item) => {
      const idVal = item.id ?? item.ID;
      if (typeof idVal === 'string') return idVal.trim() === '';
      if (typeof idVal === 'number') return false;
      return !idVal;
    });

    if (invalidRows.length) {
      dispatch(showSnackbar({ message: 'ID를 입력하세요.', type: 'error' }));
      return false;
    }

    return true;
  };

  //폼 상태값 리셋
  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    setExcelData([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };
  //#endregion

  return (
    <>
      <div className="wrap">
        <MEM_BASIC
          navigate={navigate}
          dispatch={dispatch}
          userInfo={userInfo}
          rowData1={rowData1}
          setRowData1={setRowData1}
          selectedRowData1={selectedRowData1}
          setSelectedRowData1={setSelectedRowData1}
          changedRowData1={changedRowData1}
          setChangedRowData1={setChangedRowData1}
          setDeletedRowData1={setDeletedRowData1}
          modalToggle4={modalToggle4}
          setModalToggle4={setModalToggle4}
          selectedCustCd={selectedCustCd}
          setSelectedCustCd={setSelectedCustCd}
          selectedDepCd={selectedDepCd}
          setSelectedDepCd={setSelectedDepCd}
          modalToggle1={modalToggle1}
          setModalToggle1={setModalToggle1}
          modalToggle3={modalToggle3}
          setModalToggle3={setModalToggle3}
          modalRowData1={modalRowData1}
          setModalRowData1={setModalRowData1}
          selectedModalRowData1={selectedModalRowData1}
          setSelectedModalRowData1={setSelectedModalRowData1}
          modalRowData3={modalRowData3}
          selectedModalRowData3={selectedModalRowData3}
          setSelectedModalRowData3={setSelectedModalRowData3}
          modalSearchText={modalSearchText}
          setModalSearchText={setModalSearchText}
          clickRowId={clickRowId}
          setClickRowId={setClickRowId}
          depCodeList={depCodeList}
          setDepCodeList={setDepCodeList}
          authCodeList={authCodeList}
          setAuthCodeList={setAuthCodeList}
          excelData={excelData}
          setExcelData={setExcelData}
          fileInputRef={fileInputRef}
          gridRef1={gridRef1}
          gridRef2={gridRef2}
          gridRef3={gridRef3}
          selectedRowNosRef={selectedRowNosRef}
          lastCheckedIndexRef={lastCheckedIndexRef}
          clickRowIndex1={clickRowIndex1}
          setClickRowIndex1={setClickRowIndex1}
          approveRef={approveRef}
          // 함수
          SearchLogic1={SearchLogic1}
          SearchLogic2={SearchLogic2}
          SearchLogic3={Search3}
          search6={search6}
          SaveLogic1={SaveLogic1}
          SaveLogic2={SaveLogic2}
          SaveLogic3={SaveLogic3}
          SaveLogic6={SaveLogic6}
          ExcelUpload1={ExcelUpload1}
          ExcelDownload={ExcelDownload1}
          HandleExcelFileInputChange={HandleExcelFileInputChange}
          handleRowSelection={handleRowSelection}
          MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
          RestoreRow1={deleteHandler1.RestoreRow}
          NewYnErrorMsg={NewYnErrorMsg}
          DeleteNewRow1={deleteHandler1.DeleteNewRow}
          handleCoChange={handleCoChange}
          handleCustChange={handleCustChange}
          validateSelection={validateSelection}
          validateContractMember={validateContractMember}
          validateExcelSave={validateExcelSave}
          positionList={positionList}
          modalToggle2={modalToggle2}
          setModalToggle2={setModalToggle2}
          selectedPositions={selectedPositions}
          setSelectedPositions={setSelectedPositions}
          newPositionText={newPositionText}
          setNewPositionText={setNewPositionText}
          newlyAddedPositions={newlyAddedPositions}
          setNewlyAddedPositions={setNewlyAddedPositions}
          deletedPositions={deletedPositions}
          setDeletedPositions={setDeletedPositions}
          SaveLogic4={SaveLogic4}
          AppointBusinessOwner={AppointBusinessOwner}
          ConfirmAppointBusinessOwner={ConfirmAppointBusinessOwner}
          CancelAppointBusinessOwner={CancelAppointBusinessOwner}
          DEFAULT_POSITION_LIST={DEFAULT_POSITION_LIST}
        />
        <Loading open={loading} />
        {/* 총괄관리자 권한 변경 후 재로그인 안내 */}
        <Dialog
          open={reloginDialogOpen}
          disableEscapeKeyDown={true}
          onBackdropClick={() => {}}
          onClose={() => {}}
          fullWidth
          maxWidth="xs"
          useCloseButton={false}
          useSaveButton={false}
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflow: 'hidden',
            },
          }}
          title={
            <Box
              sx={{
                px: 2.5,
                py: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                background:
                  'linear-gradient(135deg, rgba(46,180,80,1) 0%, rgba(27,189,46,1) 55%, rgba(25,118,210,1) 100%)',
                color: '#fff',
              }}
            >
              <Box
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255,255,255,0.16)',
                  border: '1px solid rgba(255,255,255,0.22)',
                }}
              >
                <AdminPanelSettingsRounded sx={{ fontSize: 26 }} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: '1.05rem', fontWeight: 800 }}>
                  권한 변경 안내
                </Typography>
                <Typography sx={{ fontSize: '0.85rem', opacity: 0.92 }}>
                  보안을 위해 재로그인이 필요합니다
                </Typography>
              </Box>
              <Box
                sx={{
                  px: 1.2,
                  py: 0.6,
                  borderRadius: 999,
                  backgroundColor: 'rgba(255,255,255,0.18)',
                  border: '1px solid rgba(255,255,255,0.24)',
                  fontWeight: 800,
                  fontSize: '0.9rem',
                  minWidth: 46,
                  textAlign: 'center',
                }}
              >
                {reloginSecondsLeft}s
              </Box>
            </Box>
          }
          content={
            <Box sx={{ px: 1, pt: 1, pb: 0.5 }}>
              <Typography
                sx={{ fontSize: '0.98rem', fontWeight: 700, mb: 0.5 }}
              >
                총괄관리자 권한이 변경되었습니다.
              </Typography>
              <Typography sx={{ fontSize: '0.9rem', color: 'text.secondary' }}>
                보안을 위해{' '}
                <b style={{ color: '#1976d2' }}>{reloginSecondsLeft}초</b> 후
                로그인 화면으로 이동합니다. 지금 바로 이동하려면{' '}
                <b style={{ color: '#2CA900' }}>확인</b>을 눌러주세요.
              </Typography>
              <Box sx={{ mt: 2 }}>
                <LinearProgress
                  variant="determinate"
                  value={Math.max(
                    0,
                    Math.min(100, (reloginSecondsLeft / 10) * 100)
                  )}
                  sx={{
                    height: 10,
                    borderRadius: 999,
                    backgroundColor: 'rgba(0,0,0,0.08)',
                    '& .MuiLinearProgress-bar': {
                      borderRadius: 999,
                      background:
                        'linear-gradient(90deg, rgba(25,118,210,1) 0%, rgba(46,180,80,1) 65%, rgba(27,189,46,1) 100%)',
                    },
                  }}
                />
              </Box>
            </Box>
          }
          actions={
            <Box sx={{ width: '100%', display: 'flex', gap: 1, px: 1, pb: 1 }}>
              <Button
                fullWidth
                name="확인"
                onClick={redirectToLogin}
                sx={{
                  height: 40,
                  borderRadius: 2,
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#1565c0' },
                  fontWeight: 800,
                }}
              />
            </Box>
          }
        />
      </div>
      <MuiDialog
        open={excelImportModeOpen}
        onClose={HandleExcelImportModeClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              pr: 0,
            }}
          >
            <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
              엑셀 업로드 방식을 선택하세요
            </Typography>
            <IconButton
              aria-label="닫기"
              size="small"
              onClick={HandleExcelImportModeClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 2,
            }}
          >
            <Paper
              elevation={2}
              sx={{
                flex: 1,
                p: 2.5,
                borderRadius: 2,
                border: '1px solid #e3eaf2',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                기존 내역에 추가
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 1.5 }}
              >
                현재 등록된 인력은 유지하고, 엑셀에 있는 신규 전화번호만
                추가합니다.
              </Typography>
              <Box component="ul" sx={{ m: 0, pl: 2, mb: 2, flex: 1 }}>
                <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                  기존 인력 행은 그대로 유지됩니다.
                </Typography>
                <Typography component="li" variant="body2">
                  엑셀에 이미 등록된 전화번호는 건너뜁니다.
                </Typography>
              </Box>
              <MuiButton
                variant="outlined"
                fullWidth
                onClick={() => HandleExcelImportModeSelect('append')}
              >
                추가로 업로드
              </MuiButton>
            </Paper>

            <Paper
              elevation={2}
              sx={{
                flex: 1,
                p: 2.5,
                borderRadius: 2,
                border: '1px solid #fff3e0',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                기존 내역 덮어쓰기
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 1.5 }}
              >
                엑셀 데이터를 기준으로 기존 인력을 갱신하고, 엑셀에 없는 인력은
                삭제 표시합니다.
              </Typography>
              <Box component="ul" sx={{ m: 0, pl: 2, mb: 2, flex: 1 }}>
                <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                  동일 전화번호는 엑셀 내용으로 갱신됩니다.
                </Typography>
                <Typography component="li" variant="body2">
                  엑셀에 없는 인력은 삭제 표시됩니다.
                </Typography>
              </Box>
              <MuiButton
                variant="contained"
                color="warning"
                fullWidth
                onClick={() => HandleExcelImportModeSelect('replace')}
              >
                덮어쓰기 업로드
              </MuiButton>
            </Paper>
          </Box>
        </DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <MuiButton onClick={HandleExcelImportModeClose}>취소</MuiButton>
        </Box>
      </MuiDialog>
    </>
  );
}

export default MEM_BASICF;
